import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Homepage from "../HomePage/HomePage";
import AboutPage from "../AboutPage/AboutPage";
import ShopPage from "../ShopPage";
import ProductSinglePage from "../ProductSinglePage";
import CartPage from "../CartPage";
import CheckoutPage from "../CheckoutPage";
import OrderRecived from "../OrderRecived";
import PaymentCreditcardPage from "../PaymentPage/creditcard";
import PaymentSTCPayPage from "../PaymentPage/stcpay";
import PaymentApplepayPage from "../PaymentPage/applepay";
import ContactPage from "../ContactPage/ContactPage";
import ErrorPage from "../ErrorPage/ErrorPage";
import LoginPage from "../LoginPage";
import LogoutPage from "../LogoutPage";
import SignUpPage from "../SignUpPage";
import ForgotPassword from "../ForgotPassword";
import { useLang } from "../../context/LangContext";

// Import CSS files
import "../../css/flaticon.css"; // English font styles
import "../../css/font-arabic.css"; // Arabic font styles
import PrivacyPolicyPage from "../PrivacyPolicyPage/PrivacyPolicyPage";

const AllRoute = () => {
  const { lang } = useLang();
  const isArabic = lang === "ar";

  return (
    <div className={`App ${isArabic ? "arabic-font" : "english-font"}`} dir={isArabic ? "rtl" : "ltr"}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="home" element={<Homepage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="shop" element={<ShopPage />} />
          <Route path="product-single/:slug" element={<ProductSinglePage />} />
          <Route path="cart" element={<CartPage />} />
          <Route path="checkout" element={<CheckoutPage />} />
          <Route path="order_received" element={<OrderRecived />} />
          <Route path="payment-creditcard" element={<PaymentCreditcardPage />} />
          <Route path="payment-applepay" element={<PaymentApplepayPage />} />
          <Route path="payment-stcpay" element={<PaymentSTCPayPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="logout" element={<LogoutPage />} />
          <Route path="register" element={<SignUpPage />} />
          <Route path="forgot" element={<ForgotPassword />} />
          <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
